'use strict';
module.exports = /^#!.*/;



/*****************
 ** WEBPACK FOOTER
 ** ./~/shebang-regex/index.js
 ** module id = 435
 ** module chunks = 0
 **/